import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';


const json = {
  1: { // Exercise num
    unit: 'Unit 5',
    id: 'WB3-U5-P39-E1',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page39/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page39/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/3.jpg', input: true, answer: "He does not like balloons." },
        { url: 'img/FriendsPlus/Page39/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page39/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/6.jpg', input: true, answer: "She doesn't like eggs." },
        { url: 'img/FriendsPlus/Page39/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page39/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/9.jpg', input: true, answer: "I do not like tigers." },
        { url: 'img/FriendsPlus/Page39/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page39/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/12.jpg', input: true, answer: "My grandpa doesn't like cake." },
        { url: 'img/FriendsPlus/Page39/E1/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page39/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/15.jpg', input: true, answer: "My mom does not like cats." },
        { url: 'img/FriendsPlus/Page39/E1/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page39/E1/17.jpg' },
      ],


    ],
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'WB3-U5-P39-E2',
    audio: '',
    video: '',
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E2/1.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E2/2.jpg' },
      ]
    ]
  },
  3: { // Exercise num
    unit: 'Unit 5',
    id: 'WB1-U5-P39-E3',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page39/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page39/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page39/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page39/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page39/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/13.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page39/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/16.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page39/E3/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page39/E3/18.jpg' },
      ],



    ],
  },



}

export default json;